import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { api } from "src/shared/setup/API/api";

interface IHandleGet {
  itensPerPage: number;
  currentPage: number;
  nameSearch: string;
}

export const useHttpGrupoImposto = () => {
  const { setQtd_registros, setLoadingTable } = useConfigPageContext();
  const { setListGrupoImposto } = useContextProdutor();
  const { handleGetAlert } = useLayoutMainContext();

  const handleGet = async (body: IHandleGet) => {
    setLoadingTable(true);

    api
      .post("/paginationGruposImpostos", {
        ...body,
        limit: body.itensPerPage,
        filter: body.nameSearch,
        page: body.currentPage,
      })
      .then((res) => {
        setListGrupoImposto(res.data.data);
        setQtd_registros(res.data.count);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
